import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import { CompanyQuery } from "../../../generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../useGraphQlClient";
import { REACT_QUERY_OPTIONS_NEVER_REFETCH } from "../utils";

const companyQuery = graphql(`
  query company($includeInactive: Boolean = false) {
    company {
      users(includeInactive: $includeInactive) {
        guid
        firstName
        lastName
        active
      }
    }
  }
`);

export type Company = CompanyQuery["company"];

type UseCompanyOptions = {
  includeInactive?: boolean;
};

export function useCompany(
  hookOptions?: UseCompanyOptions,
  options?: UseQueryOptions<CompanyQuery, unknown, CompanyQuery, QueryKey>,
) {
  const includeInactive = !!hookOptions?.includeInactive;

  const { data, ...rest } = useGraphQlQuery(
    ["company", includeInactive],
    companyQuery,
    [{ includeInactive }],
    {
      ...REACT_QUERY_OPTIONS_NEVER_REFETCH,
      ...options,
    },
  );

  return { data: data?.company, ...rest };
}
